import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "limited-time" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "full-width-bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "description flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "父親節88辛苦了 限定推出"),
    /*#__PURE__*/_createElementVNode("p", null, " 總是默默付出，HORLaY 嚴選貼心禮物提案，送給不善表達的爸爸。總是默默付出，HORLaY 嚴選貼心禮物提案，送給不善表達的爸爸總是默默付出，HORLaY 嚴選貼心禮物提案，送給不善表達的爸爸總是默默付出，HORLaY 嚴選貼心禮物提案，送給不善表達的爸爸 ")
  ])
], -1)
const _hoisted_3 = { class: "g-container flex flex-col sm:mt-10 px-[16px] sm:p-0 sm:gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SquareItemList = _resolveComponent("SquareItemList")!
  const _component_ProductClassIconList = _resolveComponent("ProductClassIconList")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_ProductClassItemList = _resolveComponent("ProductClassItemList")!
  const _component_ProductItemList = _resolveComponent("ProductItemList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Banner, { style: {"background-color":"#f5f5f5"} }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Title, {
        class: "g-title-type2 mt-[60px] mb-[40px] sm:my-[60px]",
        title: '免運專區'
      }),
      _createVNode(_component_SquareItemList, {
        direction: 'left',
        showRectangleItem: false
      }),
      _createVNode(_component_Title, {
        class: "g-title-type2 mt-[60px] mb-[40px] sm:my-[60px]",
        title: '期間限定'
      }),
      _createVNode(_component_ProductClassIconList),
      _createVNode(_component_UnderLine),
      _createVNode(_component_ProductClassItemList),
      _createVNode(_component_ProductItemList, { class: "hidden sm:block mt-[36px] sm:mt-[30px]" }),
      _createVNode(_component_ProductItemList, {
        class: "sm:hidden mt-[36px] sm:mt-[30px]",
        row: 2,
        isMobile: true
      })
    ])
  ]))
}